/**
 * Function that's useful for type narrowing, if the type at the final else / default
 * does not equal never, you're probably missing some cases.
 */
export function assertNever(_value: never) {
  return undefined as never;
}
